import { AutocompletePredictionTypes } from '../types';
import { CountryCode } from 'types/countries';
import { categorizePredictions } from '../predictionClassifier';
import { fetchPlacePredictions, requireAutocompleteService } from './placePredictions';

// Sent together as one request. No provinces (they come from go-search) and no
// postal codes (residential search doesn't show them).
const RESIDENTIAL_PLACE_TYPES = [
  AutocompletePredictionTypes.LOCALITY, // cities and towns
  AutocompletePredictionTypes.SUBLOCALITY, // districts inside a city, e.g. Edmonton North, Brooklyn
  AutocompletePredictionTypes.NEIGHBORHOOD, // neighbourhoods, e.g. Yorkville
  AutocompletePredictionTypes.ROUTE, // street names, e.g. Yonge St
  AutocompletePredictionTypes.STREET_ADDRESS, // full addresses, e.g. 123 Queen St W
] as const;

// Residential search (Zoocasa, eXp Realty, eXp In-Service): 1 request.
export async function queryResidentialPlaces(input: string, country: readonly CountryCode[]) {
  const autocompleteService = await requireAutocompleteService();
  const predictions = await fetchPlacePredictions(autocompleteService, input, RESIDENTIAL_PLACE_TYPES, country);
  return categorizePredictions(predictions);
}
